export const DEG2RAD = Math.PI / 180;
export const RAD2DEG = 180 / Math.PI;

/** Normalise an angle to [0, 360). */
export function norm360(deg: number): number {
  const x = deg % 360;
  return x < 0 ? x + 360 : x;
}

/** Signed smallest difference a-b in (-180, 180]. */
export function angleDiff(a: number, b: number): number {
  let d = norm360(a) - norm360(b);
  if (d > 180) d -= 360;
  if (d <= -180) d += 360;
  return d;
}

/** Unsigned angular separation in [0, 180]. */
export function separation(a: number, b: number): number {
  return Math.abs(angleDiff(a, b));
}

export function sinDeg(deg: number): number {
  return Math.sin(deg * DEG2RAD);
}
export function cosDeg(deg: number): number {
  return Math.cos(deg * DEG2RAD);
}
export function tanDeg(deg: number): number {
  return Math.tan(deg * DEG2RAD);
}
export function atan2Deg(y: number, x: number): number {
  return norm360(Math.atan2(y, x) * RAD2DEG);
}
export function asinDeg(x: number): number {
  return Math.asin(Math.min(1, Math.max(-1, x))) * RAD2DEG;
}

/** Is angle x inside the arc going forward (counter-clockwise) from a to b? */
export function inArc(x: number, a: number, b: number): boolean {
  const span = norm360(b - a);
  const off = norm360(x - a);
  return off < span;
}

/** Format a longitude as degrees°minutes' within its sign, e.g. 17°42'. */
export function formatDegMin(degInSign: number): string {
  const d = Math.floor(degInSign);
  const m = Math.round((degInSign - d) * 60);
  if (m === 60) return `${d + 1}°00'`;
  return `${d}°${String(m).padStart(2, '0')}'`;
}
